import { BankingValueObjectsCardStatusEnum } from 'generated/resources/graphql'

export const isPending = (card: { status: BankingValueObjectsCardStatusEnum }): boolean => {
  return card.status === 'pending'
}
